import React, { ReactElement } from 'react'

import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'

import { BillsHoverActions } from './elements/BillsHoverActions'
import { InvoicesHoverActions } from './elements/InvoicesHoverActions'

interface TransactionsTableStaticActionsProps {
  isVoided?: boolean
  originatorId: string
  originatorType?: TransactionOriginatorType
}

export const TransactionsTableHoverActions = ({
  isVoided,
  originatorId,
  originatorType,
}: TransactionsTableStaticActionsProps): ReactElement => {
  if (isVoided) {
    return <></>
  }

  switch (originatorType) {
    case TransactionOriginatorType.Bill:
      return <BillsHoverActions originatorId={originatorId} />
    case TransactionOriginatorType.Invoice:
      return <InvoicesHoverActions originatorId={originatorId} />
    default:
      return <></>
  }
}
